import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { AbstractTextFileService } from './textFileService.js';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';
import { ICodeEditorService } from 'vscode/vscode/vs/editor/browser/services/codeEditorService';
import { IModelService } from 'vscode/vscode/vs/editor/common/services/model';
import { ILanguageService } from 'vscode/vscode/vs/editor/common/languages/language';
import { ITextResourceConfigurationService } from 'vscode/vscode/vs/editor/common/services/textResourceConfiguration';
import { IDialogService, IFileDialogService } from 'vscode/vscode/vs/platform/dialogs/common/dialogs.service';
import { IFileService } from 'vscode/vscode/vs/platform/files/common/files.service';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { IElevatedFileService } from 'vscode/vscode/vs/workbench/services/files/common/elevatedFileService.service';
import { IFilesConfigurationService } from 'vscode/vscode/vs/workbench/services/filesConfiguration/common/filesConfigurationService.service';
import { ILifecycleService } from 'vscode/vscode/vs/workbench/services/lifecycle/common/lifecycle.service';
import { IPathService } from 'vscode/vscode/vs/workbench/services/path/common/pathService.service';
import { IUntitledTextEditorService } from 'vscode/vscode/vs/workbench/services/untitled/common/untitledTextEditorService.service';
import { IUriIdentityService } from 'vscode/vscode/vs/platform/uriIdentity/common/uriIdentity.service';
import { IWorkingCopyFileService } from 'vscode/vscode/vs/workbench/services/workingCopy/common/workingCopyFileService.service';
import { IDecorationsService } from 'vscode/vscode/vs/workbench/services/decorations/common/decorations.service';

let BrowserTextFileService = class BrowserTextFileService extends AbstractTextFileService {
    constructor(fileService, untitledTextEditorService, lifecycleService, instantiationService, modelService, environmentService, dialogService, fileDialogService, textResourceConfigurationService, filesConfigurationService, codeEditorService, pathService, workingCopyFileService, uriIdentityService, languageService, elevatedFileService, logService, decorationsService) {
        super(fileService, untitledTextEditorService, lifecycleService, instantiationService, modelService, environmentService, dialogService, fileDialogService, textResourceConfigurationService, filesConfigurationService, codeEditorService, pathService, workingCopyFileService, uriIdentityService, languageService, logService, elevatedFileService, decorationsService);
        this.registerListeners();
    }
    registerListeners() {
        this._register(this.lifecycleService.onBeforeShutdown(event => event.veto(this.onBeforeShutdown(), 'veto.textFiles')));
    }
    onBeforeShutdown() {
        if (( this.files.models.some(model => model.hasState(2 )))) {
            return true;
        }
        return false;
    }
};
BrowserTextFileService = ( __decorate([
    ( __param(0, IFileService)),
    ( __param(1, IUntitledTextEditorService)),
    ( __param(2, ILifecycleService)),
    ( __param(3, IInstantiationService)),
    ( __param(4, IModelService)),
    ( __param(5, IWorkbenchEnvironmentService)),
    ( __param(6, IDialogService)),
    ( __param(7, IFileDialogService)),
    ( __param(8, ITextResourceConfigurationService)),
    ( __param(9, IFilesConfigurationService)),
    ( __param(10, ICodeEditorService)),
    ( __param(11, IPathService)),
    ( __param(12, IWorkingCopyFileService)),
    ( __param(13, IUriIdentityService)),
    ( __param(14, ILanguageService)),
    ( __param(15, IElevatedFileService)),
    ( __param(16, ILogService)),
    ( __param(17, IDecorationsService))
], BrowserTextFileService));

export { BrowserTextFileService };
